/* ==========================================================================
   NeverLeafs Homepage, JS
   Product card hover image swap + Quick-add AJAX
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Product card hover image swap ---------- */
  function initImageSwap() {
    var cards = document.querySelectorAll('.nhp-product-card');
    cards.forEach(function (card) {
      var primary = card.querySelector('.nhp-product-card__img--primary');
      var hover = card.querySelector('.nhp-product-card__img--hover');
      if (!primary || !hover) return;

      card.addEventListener('mouseenter', function () {
        primary.style.opacity = '0';
        hover.style.opacity = '1';
      });
      card.addEventListener('mouseleave', function () {
        primary.style.opacity = '1';
        hover.style.opacity = '0';
      });
    });
  }

  /* ---------- Quick-add AJAX ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nhp-product-card__quick-add');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('nhp-product-card__quick-add--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.classList.remove('nhp-product-card__quick-add--loading');
          btn.classList.add('nhp-product-card__quick-add--done');
          setTimeout(function () {
            btn.classList.remove('nhp-product-card__quick-add--done');
          }, 1200);

          /* Update cart count in header */
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var badges = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
              badges.forEach(function (el) { el.textContent = cart.item_count; });
            });
        })
        .catch(function () {
          btn.classList.remove('nhp-product-card__quick-add--loading');
        });
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initImageSwap();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
